import { ShippingOptionEditProps } from "./shipping-option-edit.types";
import styles from "./shipping-option-edit.module.scss";
import cl from "classnames";
import { Button, Input, LabeledLine } from "@touche-lts/panel-ui/dist";
import { ValueTagEditor } from "components";
import { InputSelect } from "./input-select";
import { observer } from "mobx-react-lite";
import { useRootStore } from "mobx-stores/store-provider";
import { RadioButton } from "./radio-button";
import { CheckboxButton } from "./checkbox-button";

const ShippingOptionEditComponent = (props: ShippingOptionEditProps) => {
  const { className, style } = props;

  const {
    storeShippingsStore: {
      shippingChronoUnitsAsSelectOptions,
      onCancelEditingClick,
      shippingToEdit,
      setShippingToEditProps,
      onCountryAdd,
      onCountryRemove,
      onSaveEditingClick,
      getErrorMessage,
    },
  } = useRootStore();

  return (
    <div className={cl(styles.container, className)} style={style}>
      <LabeledLine colorPreset="dark" label="Name">
        <Input
          colorPreset="dark"
          placeholder="Shipping name..."
          style={{ width: 300 }}
          value={shippingToEdit.name}
          onChange={(name) => setShippingToEditProps({ name })}
          // errorMessage={getErrorMessage('name')} // Text Color issue
        />
      </LabeledLine>
      {getErrorMessage("name") && (
        <div
          style={{
            color: "red",
            fontSize: "14px",
            textAlign: "left",
            left: "131px",
            position: "relative",
            margin: "7px",
          }}
        >
          {getErrorMessage("name")}
        </div>
      )}
      <LabeledLine
        colorPreset="dark"
        label="Delivery time"
        className={styles.marginTop}
      >
        <InputSelect
          inputProps={{
            placeholder: "Delivery time...",
            value: shippingToEdit.deliveryTime,
            onChange: (deliveryTime) =>
              setShippingToEditProps({ deliveryTime }),
            // errorMessage: getErrorMessage('deliveryTime') Text Color issue
          }}
          selectProps={{
            options: shippingChronoUnitsAsSelectOptions,
            noNoneOption: true,
            value: shippingToEdit.chronoUnit,
            onChange: (chronoUnit: any) =>
              setShippingToEditProps({ chronoUnit }),
          }}
        />
      </LabeledLine>
      {getErrorMessage("deliveryTime") && (
        <div
          style={{
            color: "red",
            fontSize: "14px",
            textAlign: "left",
            left: "131px",
            position: "relative",
            margin: "7px",
          }}
        >
          {getErrorMessage("deliveryTime")}
        </div>
      )}
      <LabeledLine
        colorPreset="dark"
        label="Price"
        alignItems="stretch"
        className={styles.marginTop}
      >
        <div>
          <div className={styles.flexLine}>
            <div className={styles.priceContainer}>
              <RadioButton
                selected={!shippingToEdit.freeShipping}
                onClick={() => setShippingToEditProps({ freeShipping: false })}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputSelect
                  style={{ marginLeft: 5, width: 240 }}
                  inputProps={{
                    placeholder: "Price...",
                    value: shippingToEdit.price,
                    onChange: (price: any) => setShippingToEditProps({ price }),
                    // errorMessage: getErrorMessage('price') Text Color issue
                  }}
                  selectProps={{
                    options: [{ label: "USD", value: "USD" }],
                    value: "USD",
                    noNoneOption: true,
                  }}
                />
                {getErrorMessage("price") && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      margin: "7px",
                    }}
                  >
                    {getErrorMessage("price")}
                  </div>
                )}
              </div>
            </div>
            <div className={styles.freeShippingAboveContainer}>
              <CheckboxButton
                checkboxProps={{
                  isChecked: shippingToEdit.freeShippingAbove,
                }}
                label="Free shipping above"
                onClick={() =>
                  setShippingToEditProps({
                    freeShippingAbove: !shippingToEdit.freeShippingAbove,
                  })
                }
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputSelect
                  style={{ width: 240 }}
                  inputProps={{
                    placeholder: "Amount...",
                    value: shippingToEdit.freeAmount,
                    onChange: (freeAmount: any) =>
                      setShippingToEditProps({ freeAmount }),
                    // errorMessage: getErrorMessage('freeAmount') Text Color issue
                  }}
                  selectProps={{
                    options: [{ label: "USD", value: "USD" }],
                    value: "USD",
                    noNoneOption: true,
                  }}
                />
                {getErrorMessage("freeAmount") && (
                  <div
                    style={{
                      color: "red",
                      fontSize: "14px",
                      textAlign: "left",
                      margin: "7px",
                    }}
                  >
                    {getErrorMessage("freeAmount")}
                  </div>
                )}
              </div>
            </div>
          </div>
          <RadioButton
            className={styles.marginTop}
            label="Free shipping"
            selected={shippingToEdit.freeShipping}
            onClick={() => setShippingToEditProps({ freeShipping: true })}
          />
        </div>
      </LabeledLine>
      <LabeledLine
        colorPreset="dark"
        label="Ships to"
        alignItems="stretch"
        className={styles.marginTop}
      >
        <ValueTagEditor
          editMode
          style={{ width: "100%" }}
          valueTags={shippingToEdit.countries.map((c) => ({
            valueName: c,
            onRemove: () => onCountryRemove(c),
          }))}
          onInputValueAdded={onCountryAdd}
        />
      </LabeledLine>
      {getErrorMessage("countries") && (
        <div
          style={{
            color: "red",
            fontSize: "14px",
            textAlign: "left",
            margin: "7px",
            left: "131px",
            position: "relative",
          }}
        >
          {"Country name is too short (minimum is 1 character)"}
        </div>
      )}

      <div className={styles.buttonsContainer}>
        <Button
          preset="secondary"
          colorPreset="dark"
          onClick={onCancelEditingClick}
        >
          Cancel
        </Button>
        <Button preset="primary" onClick={onSaveEditingClick}>
          Save
        </Button>
      </div>
    </div>
  );
};

const ShippingOptionEdit = observer(ShippingOptionEditComponent);
export { ShippingOptionEdit };
